import { render, staticRenderFns } from "./bf.vue?vue&type=template&id=e45ca2ee&scoped=true"
import script from "./bf.vue?vue&type=script&lang=js"
export * from "./bf.vue?vue&type=script&lang=js"
import style0 from "./bf.vue?vue&type=style&index=0&id=e45ca2ee&prod&lang=less&scoped=true"
import style1 from "./bf.vue?vue&type=style&index=1&id=e45ca2ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45ca2ee",
  null
  
)

export default component.exports